module.exports = __webpack_public_path__ + "assets/img/3201.62b656f4.png";